// @ts-strict-ignore
import { isBrowser } from 'utils/browser';
import { deleteCookie, getListCookie } from 'utils/cookies';
import { uuid } from 'utils/functional';

// Types

export type State = ReadonlyArray<FlashMessageType>;

type PushAction = {
  type: 'PUSH_FLASH_MESSAGE';
  message: FlashMessageType;
};
type RemoveAction = {
  type: 'REMOVE_FLASH_MESSAGE';
  id: string;
};
type ClearAction = {
  type: 'CLEAR_FLASH_MESSAGES';
};
export type Action = PushAction | RemoveAction | ClearAction;

// Reducer

// need unique ID for React list of messages (using index caused issues)
const getFlashMessageId = () => uuid() + new Date().getTime().toString(36);

const getFlashMessages = (): State => {
  if (isBrowser()) {
    const messages = getListCookie('flashMessages');
    deleteCookie('flashMessages');
    return messages.map((message) => ({ ...message, id: getFlashMessageId() }));
  }

  return [];
};

const initialState: State = getFlashMessages();

export function flashMessagesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
): State {
  switch (action.type) {
    case 'PUSH_FLASH_MESSAGE':
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
      action.message.id = getFlashMessageId();
      return [...state, action.message];

    case 'REMOVE_FLASH_MESSAGE': {
      const toRemove = action.id;
      return state.filter((m) => m.id !== toRemove);
    }

    case 'CLEAR_FLASH_MESSAGES':
      // remove all messages that aren't sticky
      return [...state.filter((m) => m.sticky)];

    default:
      return state;
  }
}

// Actions

export const pushFlashMessage = (message: FlashMessageType): PushAction => ({
  type: 'PUSH_FLASH_MESSAGE',
  message,
});
export const removeFlashMessage = (id: string): RemoveAction => ({
  type: 'REMOVE_FLASH_MESSAGE',
  id,
});
export const clearFlashMessages = (): ClearAction => ({
  type: 'CLEAR_FLASH_MESSAGES',
});
